import { Component, Input, OnInit } from '@angular/core';

import { Page } from '../../../../models/page';
import { PageService } from '../../../../services/page.service';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { PageChangedEvent } from '../../../../utils/events/page-changed-event';
import { CommunicationService } from '../../../../services/communication.service';
import { SidebarService } from '../../../../services/sidebar.service';
import { PreviewPages } from './preview-pages';
import { environment } from '../../../../../environments/environment';
import { ThumbnailPageImageComponent } from '../thumbnail-page-image/thumbnail-page-image.component';

@Component({
    selector: 'sidebar-single-chapter-page',
    templateUrl: './single-chapter-page.component.html',
    styleUrls: ['./single-chapter-page.component.scss'],
    standalone: true,
    imports: [
        ThumbnailPageImageComponent
    ]
})
export class SingleChapterPageComponent implements OnInit {

    private static MAX_WIDTH = 122;
    private static PADDING_VALUE = 6;

    @Input() previewPages: Array<PreviewPages> = [];
    width: number;
    height: number;

    constructor(public sidebarService: SidebarService,
                public applicationStateService: ApplicationStateService,
                private pageService: PageService,
                private communicationService: CommunicationService) {
    }

    ngOnInit(): void {
        this.calculateDimensions();
    }

    getPreviewPageNumbers(pages: Array<Page>): Array<number> {
        const pageNumbers = [];
        pages.forEach(page => {
            pageNumbers.push(this.getRealPageNumber(page));
        });

        return pageNumbers.filter(ele => ele > 0);
    }

    getRealPageNumber(page: Page): number {
        if (page) {
            return this.pageService.getRealPageNumber(page.index);
        }

        return -1;
    }

    turnToPage(pages: Array<Page>, previewId: number): void {
        let indexOfFirstRealPage;

        for (const page of pages) {
            if (page) {
                indexOfFirstRealPage = page.index;
                break;
            }
        }

        // this.sidebarService.activePagesContainer = previewId;
        const pageChangeEvent = new PageChangedEvent();
        pageChangeEvent.moveToPage = indexOfFirstRealPage;
        this.communicationService.announcePageTurn(pageChangeEvent);

        if (window.window.innerWidth <= (environment.mobileBreakPoint + 1)) {
            this.sidebarService.closeSidebar();
        }
    }

    isActive(preview: PreviewPages): boolean {

        const activeIndizes = [];
        for (let i = 0; i < preview.pages.length; i++) {

            const page = preview.pages[i];

            if (!page && i === 0) {
                activeIndizes.push(preview.pages[i + 1].index - 1);
            }

            if (!page && i === 1) {
                activeIndizes.push(preview.pages[i - 1].index + 1);
            }

            if (page) {
                activeIndizes.push(preview.pages[i].index);
            }
        }

        return activeIndizes.includes(this.applicationStateService.currentIndex);
    }

    private calculateDimensions(): void {

        for (const page of this.previewPages[0].pages) {
            if (page) {

                this.width = page.thumbnailImage.width;
                this.height = page.thumbnailImage.height;

                if (this.width > SingleChapterPageComponent.MAX_WIDTH) {
                    const ratio = SingleChapterPageComponent.MAX_WIDTH / this.width;
                    this.width = SingleChapterPageComponent.MAX_WIDTH - SingleChapterPageComponent.PADDING_VALUE * 2;
                    this.height *= ratio;
                    this.height -= SingleChapterPageComponent.PADDING_VALUE * 2 * ratio;
                    this.height = Math.ceil(this.height);
                }

                return;
            }
        }
    }

}
